// Use the store's existing team picker so the roster can change in the app.
document.addEventListener('click', (event) => {
  const link = event.target.closest?.('[data-mbh-asesores]');
  if (!link || event.defaultPrevented || event.button !== 0 ||
      event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
  const trigger = document.querySelector('#wa .wa__btn_popup');
  if (!trigger || !trigger.getClientRects().length) return;
  event.preventDefault();
  if (!trigger.classList.contains('wa__active')) trigger.click();
});